import { Dispatch } from 'redux';
import { Data } from './types';
import actionTypes from './actionTypes';
import { SESSION_KEY } from 'shared/constants/visitorPrioritization';
import { logger } from 'logging';

export const changeData = (data: Data) => (dispatch: Dispatch) => {
  // Persist to sessionStorage for interceptor fallback
  if (typeof window !== 'undefined' && data && Object.keys(data).length > 0) {
    try {
      sessionStorage.setItem(SESSION_KEY, JSON.stringify(data));
    } catch (error) {
      logger.error(error, 'Failed to persist VP data to sessionStorage');
    }
  }

  dispatch({
    type: actionTypes.VP_DATA_CHANGED,
    payload: data,
  });
};

export const setError =
  (flag = true, message: string) =>
  (dispatch: Dispatch) => {
    dispatch({
      type: actionTypes.VP_BLOCK_ERROR,
      payload: {
        message,
        flag,
      },
    });
  };
